export const selectRaw = state => state.gandiReduxBilling;
export const hashString = str => String(str.split('').reduce((prevHash, currVal) => Math.abs((prevHash << 5) - prevHash + currVal.charCodeAt(0)), 0));
export const selectSharingIdProp = (_, props) => props.sharingId;